export default __webpack_public_path__ + "static/media/__google_play_icon_black.ddae1526.svg";